import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core';
import { NgRedux, Select } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { Blacklist } from '../../store/entities';
import { AUnblacklist, PlaylistRemoteAppState } from '../../store';
import { environment } from '../../../environments/environment';
import { ListsModule } from '../../components/lists/lists.module';
import { SharedModule } from '../../shared.module';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AudioService } from '../../services/audio.service';
import { MatRippleModule } from '@angular/material/core';
import { PipesModule } from '../../pipes/pipes.module';
import { HeaderModule } from '../../components/header/header.module';
import { ContainersModule } from '../containers.module';
import { Router } from '@angular/router';
import { ButtonsModule } from 'src/app/components/buttons/buttons.module';
import { MatButtonModule } from '@angular/material/button';

/**
 * TODO :: Improve imports here
 */
@Component({
  selector: 'mwo-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ListsModule,
    SharedModule,
    AsyncPipe,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    NgForOf,
    MatRippleModule,
    PipesModule,
    NgIf,
    HeaderModule,
    ContainersModule,
    ButtonsModule,
    MatButtonModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class BlacklistPage implements OnInit {
  @Select(['remote', 'name']) playerName$: Observable<string>;
  @Select('blacklist') blacklistList$: Observable<Blacklist[]>;
  assetsUrl = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/`;
  totalDuration = 0;
  totalLength = 0;


  constructor(private ngRedux: NgRedux<PlaylistRemoteAppState>,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private audioService: AudioService) {
  }

  ngOnInit(): void {
    this.blacklistList$.subscribe((blacklist) => {
      if (!blacklist) {
        return;
      }
      this.totalLength = 0;
      this.totalDuration = 0;
      blacklist.forEach((item) => {
        this.totalDuration += item?.media?.duration;
        this.totalLength++;
      });
    });
    // this.ngRedux.dispatch({type: 'FETCH_BLACKLIST'});
  }

  back() {
    this.router.navigate(['library']);
  }

  unblacklistAll() {
    const sub = this.blacklistList$.subscribe((blacklist) => {
      if (!blacklist) {
        return;
      }
      blacklist.forEach((item) => {
        this.ngRedux.dispatch(AUnblacklist(item.media.id));
      });
      setTimeout(() => {
        sub.unsubscribe();
      }, 300);
    });
  }

}
